/* Maison Mata — accent manuscrit (Mr De Haviland).
   Applique .mm-hand uniquement aux expressions réservées, une seule fois par section,
   jamais dans un paragraphe, un prix, un bouton ou un champ. */
(function () {
  var PHRASES = [/^handmade in bali\.?$/i, /^fait (à|a) la main\.?$/i, /^le geste de l['’]atelier\.?$/i];
  var SKIP = 'p, li, button, a.button, .button, label, input, select, textarea, .price, [class*="price"], .product-form, .cart';
  function run() {
    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      if (sec.querySelector('.mm-hand')) return;
      var els = sec.querySelectorAll('h1, h2, h3, h4, h5, h6, span, div, small, strong, em');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.children.length) continue;
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t || t.length > 32) continue;
        if (!PHRASES.some(function (r) { return r.test(t); })) continue;
        if (el.closest(SKIP)) continue;
        el.classList.add('mm-hand');
        break;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
